import { render, staticRenderFns } from "./ActualizarReglaMFSO.vue?vue&type=template&id=063e78fa"
import script from "./ActualizarReglaMFSO.vue?vue&type=script&lang=js"
export * from "./ActualizarReglaMFSO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports